import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import classnames from 'classnames';

// components
import { FormattedMessage } from 'react-intl';
import { Button } from 'dibs-elements/exports/Button';
import { CurrencyProvider } from 'dibs-buyer-layout/exports/CurrencyProvider';
import { SharedContactDealerWrapper } from '../../contactDealer/SharedContactDealerWrapper';
import {
    TradeOnboardingCoachmarkConditionalLoader,
    PDP_PLACEMENT,
} from '../../global/tradeOnboarding/TradeOnboardingCoachmarkConditionalLoader';
import { startConversationMessage } from '../pdpMessages';
import { PdpRespTradeOnApprovalCoachmarkLoader } from '../PdpRespTradeOnApprovalCoachmark/PdpRespTradeOnApprovalCoachmarkLoader';
// styles
import styles from './PdpSharedButtons.scss';

export const PdpSharedContactDealerButtonComponent = ({
    fullWidth,
    type,
    launchOrigin,
    item,
    size,
    buttonType,
    source,
    user = {},
}) => {
    const buttonClassName = classnames(styles.requestInfoButton, { [styles.fullWidth]: fullWidth });

    const contactTheSellerMessage = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.contactTheSeller"
            defaultMessage="Contact Seller"
        />
    );

    const requestCustomizationMessage = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.requestCustomization"
            defaultMessage="Request Customization"
        />
    );

    const requestPriceMessage = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.requestPrice"
            defaultMessage="Request Price"
        />
    );

    const requestMoreImages = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.requestMoreImages"
            defaultMessage="Request More Images"
        />
    );
    const requestMoreImagesAndVideos = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.requestMore"
            defaultMessage="Request More"
        />
    );

    let modalType = 'CONTACT_DEALER';
    let message;
    let coachmark = null;

    switch (type) {
        case 'REQUEST_PRICE':
            message = requestPriceMessage;
            launchOrigin = 'request price button';
            modalType = type;
            break;
        case 'REQUEST_CUSTOMIZATION':
            message = requestCustomizationMessage;
            launchOrigin = 'contact link in pdp - request customization';
            modalType = type;
            break;
        case 'REQUEST_IMAGES':
            message = requestMoreImages;
            modalType = type;
            break;
        case 'REQUEST_IMAGES_AND_VIDEOS':
            message = requestMoreImagesAndVideos;
            modalType = type;
            break;
        default:
            message =
                source === 'shipment-info-link'
                    ? contactTheSellerMessage
                    : startConversationMessage;
            coachmark = (
                <Fragment>
                    <TradeOnboardingCoachmarkConditionalLoader
                        type={PDP_PLACEMENT}
                        item={item}
                        user={user}
                    />
                    <PdpRespTradeOnApprovalCoachmarkLoader item={item} user={user} />
                </Fragment>
            );
            break;
    }

    return (
        <div className={styles.buttonWrapper}>
            {source !== 'shipment-info-link' && coachmark}
            <CurrencyProvider
                render={({ currency } = {}) => (
                    <SharedContactDealerWrapper
                        item={item}
                        launchOrigin={launchOrigin}
                        modalType={modalType}
                        user={user}
                        currency={currency}
                    >
                        {source === 'shipment-info-link' ? (
                            <a
                                className={styles.contactSellerLink}
                                dataTn="item-actions-request-information"
                            >
                                {message}
                            </a>
                        ) : (
                            <Button
                                type={buttonType}
                                className={buttonClassName}
                                dataTn="item-actions-request-information"
                                size={size}
                            >
                                {message}
                            </Button>
                        )}
                    </SharedContactDealerWrapper>
                )}
            />
        </div>
    );
};

PdpSharedContactDealerButtonComponent.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    source: PropTypes.string,
    type: PropTypes.oneOf([
        'CONTACT_DEALER',
        'REQUEST_CUSTOMIZATION',
        'REQUEST_PRICE',
        'REQUEST_IMAGES',
        'REQUEST_IMAGES_AND_VIDEOS',
    ]),
    fullWidth: PropTypes.bool,
    launchOrigin: PropTypes.string,
    buttonType: PropTypes.oneOf(['primary', 'secondary', 'textCta']),
};

PdpSharedContactDealerButtonComponent.defaultProps = {
    size: 'large',
    buttonType: 'primary',
    type: 'CONTACT_DEALER',
    launchOrigin: 'contact link in pdp - sidebar',
    fullWidth: true,
};

export const PdpSharedContactDealerButton = createFragmentContainer(
    PdpSharedContactDealerButtonComponent,
    {
        item: graphql`
            fragment PdpSharedContactDealerButton_item on Item {
                ...SharedContactDealerWrapper_item
                ...TradeOnboardingCoachmarkConditionalLoader_item
                ...PdpRespTradeOnApprovalCoachmarkLoader_item
            }
        `,
        user: graphql`
            fragment PdpSharedContactDealerButton_user on User {
                ...SharedContactDealerWrapper_user
                ...TradeOnboardingCoachmarkConditionalLoader_user
                ...PdpRespTradeOnApprovalCoachmarkLoader_user
            }
        `,
    }
);
